/** Splits comma-separated input into new seeds, skipping case-insensitive duplicates. */
export function parseSeeds(input: string, existing: string[]): string[] {
  const seen = new Set(existing.map((value) => value.toLowerCase()))

  return input
    .split(',')
    .map((part) => part.trim())
    .filter((seed) => {
      const key = seed.toLowerCase()

      if (!seed || seen.has(key)) return false

      seen.add(key)

      return true
    })
}

export function mergeSeedDraft(existing: string[], draft: string): string[] {
  return [...existing, ...parseSeeds(draft, existing)]
}
